<section [attr.aria-labelledby]="directBooking() ? 'direct-booking-title' : 'access-request-title'">
  <div class="section-heading">
    <div>
      @if (directBooking()) {
        <h2 id="direct-booking-title">Direct access booking</h2>
      } @else {
        <h2 id="access-request-title">Access request</h2>
      }
    </div>
  </div>

  <div class="workbench">
    <form class="form-surface" #bookingForm="ngForm" (ngSubmit)="submit()">
      <div class="form-grid">
        @if (!directBooking()) {
          <div class="form-field full">
            <label for="booking-lockedspace">Lockedspace</label>
            <select
              id="booking-lockedspace"
              name="mapId"
              class="form-select"
              [(ngModel)]="model.mapId"
              (ngModelChange)="selectLockedSpace()"
              required
            >
              <option value="" disabled>Select a lockedspace</option>
              @for (item of lockedSpaceOptions(); track item.id) {
                <option [value]="item.id">{{ item.label }}</option>
              }
            </select>
          </div>
        }

        <div class="form-field">
          <label for="booking-email">Email address</label>
          <input id="booking-email" name="email" class="form-control" [(ngModel)]="model.email" [readOnly]="!directBooking()" [required]="directBooking()">
        </div>
        <div class="form-field">
          <label for="booking-phone">Phone number</label>
          <input id="booking-phone" name="phone" class="form-control" [(ngModel)]="model.phone" [readOnly]="!directBooking()">
        </div>
        <div class="form-field full">
          <label for="booking-provider">System provider</label>
          <input id="booking-provider" name="systemProvider" class="form-control" [(ngModel)]="model.systemProvider" [readOnly]="!directBooking()" required>
        </div>
        <div class="form-field full">
          <div class="label-row">
            <label for="booking-item-id">Item ID</label>
            @if (directBooking()) {
              <label class="inline-check">
                <input name="createEdi" type="checkbox" [(ngModel)]="model.createEdi" (ngModelChange)="toggleEdi($event)">
                Create EDI
              </label>
            }
          </div>
          <input id="booking-item-id" name="itemId" class="form-control" [(ngModel)]="model.itemId" [readOnly]="model.createEdi" required>
          <small class="field-note">Previous: {{ previousItemId() }}</small>
        </div>
        @if (directBooking()) {
          <div class="form-field full">
            <label for="booking-lock-id">Lock ID</label>
            <input id="booking-lock-id" name="lockId" class="form-control" [(ngModel)]="model.lockId" [readOnly]="model.createEdi" required>
          </div>
        }
        <div class="form-field">
          <label for="booking-length">Length (mm)</label>
          <input id="booking-length" name="length" type="number" class="form-control" [(ngModel)]="model.length" required>
        </div>
        <div class="form-field">
          <label for="booking-width">Width (mm)</label>
          <input id="booking-width" name="width" type="number" class="form-control" [(ngModel)]="model.width" required>
        </div>
        <div class="form-field">
          <label for="booking-height">Height (mm)</label>
          <input id="booking-height" name="height" type="number" class="form-control" [(ngModel)]="model.height" required>
        </div>
        <div class="form-field">
          <label for="booking-country">Country</label>
          <select id="booking-country" name="country" class="form-select" [(ngModel)]="model.country" required>
            <option value="DK">DK</option>
            <option value="SE">SE</option>
            <option value="NO">NO</option>
            <option value="FI">FI</option>
            @if (model.systemProvider.toLowerCase() === 'swipbox') {
              <option value="PK">PK</option>
              <option value="PK2">PK2</option>
            }
          </select>
        </div>
        @if (directBooking()) {
          <div class="form-field">
            <label for="booking-box-type">Box type</label>
            <input id="booking-box-type" name="boxType" class="form-control" [(ngModel)]="model.boxType" required>
          </div>
          <div class="form-field">
            <label for="booking-preference">Booking position</label>
            <select id="booking-preference" name="bookingPreference" class="form-select" [(ngModel)]="model.bookingPreference">
              <option value="">No preference</option>
              <option value="TOP">TOP</option>
              <option value="MIDDLE">MIDDLE</option>
              <option value="BOTTOM">BOTTOM</option>
            </select>
          </div>
        }
      </div>

      <details class="form-section" [open]="!directBooking()">
        <summary>Additional values</summary>
        <div class="form-grid form-section-body">
          <div class="form-field full">
            <label for="booking-access-type">Access type</label>
            <select id="booking-access-type" name="accessType" class="form-select" [(ngModel)]="model.accessType" required>
              <option value="DELIVERY">DELIVERY</option>
              <option value="PICKUP">PICKUP</option>
              <option value="DROPOFF">DROPOFF</option>
              <option value="HANDOVER">HANDOVER</option>
            </select>
          </div>
          @if (model.accessType === 'DROPOFF') {
            <div class="form-field full">
              <label for="booking-dropoff-limit">Dropoff allowance (hours)</label>
              <input id="booking-dropoff-limit" name="dropoffTimeLimit" type="number" min="1" class="form-control" [(ngModel)]="model.dropoffTimeLimit" required>
            </div>
          }
          @if (model.accessType === 'DELIVERY') {
            <div class="form-field full">
              <label for="booking-delivery-type">Delivery type</label>
              <select id="booking-delivery-type" name="deliveryType" class="form-select" [(ngModel)]="model.deliveryType" required>
                <option value="HomeDelivery">HomeDelivery</option>
                <option value="ServicePoint">ServicePoint</option>
              </select>
            </div>
          }
          <div class="form-field">
            <label for="booking-requester">Requester ID</label>
            <input id="booking-requester" name="requesterId" class="form-control" [(ngModel)]="model.requesterId" [readOnly]="!directBooking()" required>
          </div>
          <div class="form-field">
            <label for="booking-shipper">Shipper name</label>
            <input id="booking-shipper" name="shipperName" class="form-control" [(ngModel)]="model.shipperName" [readOnly]="!directBooking()" required>
          </div>
          <div class="form-field">
            <label for="booking-date-from">Delivery date from</label>
            <input id="booking-date-from" name="deliveryDateFrom" type="date" class="form-control" [(ngModel)]="model.deliveryDateFrom" required>
          </div>
          <div class="form-field">
            <label for="booking-time-from">Time from</label>
            <input id="booking-time-from" name="deliveryTimeFrom" type="time" class="form-control" [(ngModel)]="model.deliveryTimeFrom">
          </div>
          <div class="form-field">
            <label for="booking-date-to">Delivery date to</label>
            <input id="booking-date-to" name="deliveryDateTo" type="date" class="form-control" [(ngModel)]="model.deliveryDateTo" required>
          </div>
          <div class="form-field">
            <label for="booking-time-to">Time to</label>
            <input id="booking-time-to" name="deliveryTimeTo" type="time" class="form-control" [(ngModel)]="model.deliveryTimeTo">
          </div>
          <div class="form-field full">
            <label for="booking-description">Parcel description</label>
            <textarea id="booking-description" name="description" class="form-control" rows="3" [(ngModel)]="model.description"></textarea>
          </div>
          <div class="form-field">
            <label for="booking-recipient-date">Recipient response date</label>
            <input id="booking-recipient-date" name="recipientResponseDate" type="date" class="form-control" [(ngModel)]="model.recipientResponseDate">
          </div>
          <div class="form-field">
            <label for="booking-recipient-time">Recipient response time</label>
            <input id="booking-recipient-time" name="recipientResponseTime" type="time" class="form-control" [(ngModel)]="model.recipientResponseTime">
          </div>
        </div>
      </details>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="bookingForm.invalid || creatingEdi()">
          {{ creatingEdi() ? 'Creating EDI...' : 'Submit booking' }}
        </button>
      </div>
    </form>

    <div>
      <app-api-endpoint [endpoint]="endpoint" />

      <aside class="guidance-panel" aria-label="Booking instructions">
        @if (directBooking()) {
          <p><strong>Description:</strong> Sends a request to book a compartment in a parcelbox.</p>
          <p><strong>Expected Result:</strong> The booking flow can sometimes be asynchronous, so its result will arrive through a callback. This request confirms that the booking was successfully sent to the provider.</p>
          <p><strong>Key Property to change:</strong></p>
          <ul>
            <li><strong>Item ID</strong> - Unique shipment identifier.</li>
            <li><strong>Lock ID</strong> - The BLOM ID for the service point.</li>
            <li><strong>Email Address / Phone Number</strong> - Identifies the recipient who will pick up the shipment.</li>
            <li><strong>Dimension (Length, Width, Height)</strong> - Change these values to test a box of a specific size.</li>
            <li><strong>System Provider</strong> - The name of the integrator.</li>
            <li><strong>Requester ID</strong> - Key user ID, email, or phone number of the sender.</li>
          </ul>
        } @else {
          <p><strong>Description:</strong> Sends a request to book an available lockedspace.</p>
          <p><strong>Expected Result:</strong> The flow is asynchronous, so the Access ID will arrive through a callback. The response confirms that the booking was sent to the lock provider.</p>
          <p><strong>Key Property to change:</strong></p>
          <ul>
            <li><strong>Lockedspace name</strong> - Choose from the available lockedspaces returned by Request Lockedspaces.</li>
            <li><strong>System Provider</strong> - Cannot be changed; it comes from the selected lockedspace.</li>
            <li><strong>Item ID</strong> - Unique shipment identifier.</li>
            <li><strong>Dimension (Length, Width, Height)</strong> - Change these values when testing box-size restrictions.</li>
          </ul>
        }
      </aside>

      @if (!directBooking() && lockedSpaceOptions().length === 0) {
        <div class="empty-state">No lockedspaces are available in this session.</div>
      }
      @if (requestId()) {
        <div class="status-banner warning">
          Booking accepted for asynchronous processing. Request ID: <strong>{{ requestId() }}</strong>
        </div>
      }
      <app-api-result
        [endpoint]="endpoint"
        [showEndpoint]="false"
        [request]="call.request()"
        [response]="call.response()"
        [error]="call.error()"
      />
    </div>
  </div>
</section>